import { Link } from "react-router-dom";
import Button from "../common/Button";
import { useContext, useEffect, useState } from "react";
import { Context } from "../context/MainContext";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import Loading from "../components/Loading";
import { fetchGallery } from "../api/dashboardApi";
import GalleryItem from "../components/GalleryItem";

const Gallery = () => {
  const { user } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    const handleFetchGallery = async () => {
      if (user?.id) {
        setLoading(true);
        try {
          const res = await fetchGallery(page, user?.accessToken);

          setGallery(res.data?.gallery);
          setPageCount(res.data.totalPages);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          const message =
            (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            err.toString();
          toast.error(message);
        }
      }
    };

    handleFetchGallery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, page, refresh]);

  const handlePageClick = (gallery) => {
    setPage(gallery.selected + 1);
  };

  // console.log("Gallery", Gallery);
  return (
    <div className="blog">
      <div className="blog__top">
        <Link to={"/dashboard/gallery/add"}>
          <Button height="40px">
            ADD Image <i className="ti-plus"></i>
          </Button>
        </Link>
      </div>

      <div className="blog__main">
        <h2>Gallery</h2>

        {loading ? (
          <Loading />
        ) : (
          <div className="blog__main__list">
            {gallery?.map((item) => {
              return (
                <GalleryItem
                  key={item?.id}
                  item={item}
                  setRefresh={setRefresh}
                  user={user}
                />
              );
            })}
          </div>
        )}

        {pageCount > 1 && (
          <div style={{ marginTop: 40 }}>
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              pageCount={pageCount}
              breakLabel="..."
              //   renderOnZeroPageCount={null}
              onPageChange={handlePageClick}
              // pageRangeDisplayed={itemsPerPage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
